/* LUCIELL — Winback-Staffel: Korb-Abgleich (Betreiber 05.10.2026, Teil 2).

   Geladen (defer) aus snippets/lc-ab-auslosung.liquid, nur wenn das
   Shop-Metafeld luciell.winback eine Liste traegt. Der Block data-lc-winback
   im <head> hat schon entschieden, ob diese Seite im Winback-Modus laeuft
   (window.lcWinback, html.lc-winback), und legt die Liste samt Cookie-Code in
   window.lcWinbackKopf = {codes, keks} ab.

   Hier: EINMAL je Seitenaufruf /cart.js lesen und die Sitzungs-Merker
   nachziehen, die der <head>-Block beim naechsten Seitenaufruf liest:
     - Steht ein Code der Liste in discount_codes (applicable egal — bei leerem
       Korb oder ohne Charm ist er false) → lc_wb_korb = Code, lc_wb_widerlegt
       weg. Wirkt ab dem naechsten Seitenaufruf (auch ohne Cookie).
     - Steht keiner drin → lc_wb_korb weg. Dann:
         * Cookie behauptet einen Code der Liste, Korb ist LEER → nichts weiter.
           Ein leerer Korb widerlegt nicht: Kommt ein frischer Besucher ohne
           Korb ueber /discount/<CODE>, haengt Shopify den Code womoeglich erst
           an den Korb, der beim ersten Hinzufuegen entsteht, die Kasse nimmt
           ihn aus dem Cookie. Der Winback-Modus bleibt, bis ein Korb MIT
           Artikeln entscheidet. (Messpunkt vor Live, siehe LIESMICH.) War das
           Cookie schon widerlegt, gilt der naechste Punkt.
         * Cookie behauptet einen Code der Liste, Korb hat Artikel → Merker
           lc_wb_widerlegt = dieser Code.
         * Klasse html.lc-winback sofort weg, window.lcWinback = null (auch
           wenn nur der Korb-Merker gezaehlt hatte). Der A/B-Test kommt ab dem
           naechsten Seitenaufruf zurueck (kein Umschalten mitten auf der Seite).
   Fehler (Netz, kein JSON, kein discount_codes) aendern nichts.

   Die Merker sind SITZUNGS-COOKIES (path=/, ohne Expires/Max-Age): sie gelten
   fuer alle Tabs und enden mit der Browser-Sitzung. sessionStorage gaelte nur
   je Tab — ein neuer Tab (Anzeige, Lesezeichen) liefe dann im falschen Modus.

   Nur fragen, wenn es etwas zu klaeren gibt: Cookie-Code, Merker lc_wb_korb
   oder ein Korb, der nicht nachweislich leer ist (LC_KORB_ANZAHL aus
   sections/luciell-warenkorb.liquid). Sonst keine Anfrage.

   Fasst lc-korb.js NICHT an und braucht es nicht. Tests:
   shopify/warenkorb/tests/lc-winback.test.mjs. */
(function () {
  'use strict';
  var w = window;
  var d = document;
  var KORB = 'lc_wb_korb';
  var WIDERLEGT = 'lc_wb_widerlegt';

  var kopf = w.lcWinbackKopf;
  if (!kopf || !Array.isArray(kopf.codes) || !kopf.codes.length) return;
  if (typeof w.fetch !== 'function') return;

  function lesen(k) {
    var roh = '';
    try { roh = String(d.cookie || ''); } catch (e) { return null; }
    var teile = roh.split(';');
    for (var i = 0; i < teile.length; i++) {
      var t = teile[i].replace(/^\s+/, '');
      if (t.indexOf(k + '=') !== 0) continue;
      var v = t.slice(k.length + 1);
      try { v = decodeURIComponent(v); } catch (e) {}
      return v || null;
    }
    return null;
  }
  /* Sitzungs-Cookie; null loescht. Schreibt nur, wenn sich etwas aendert. */
  function setzen(k, v) {
    if (lesen(k) === v) return;
    try {
      d.cookie = v === null
        ? k + '=; path=/; max-age=0; samesite=lax'
        : k + '=' + encodeURIComponent(v) + '; path=/; samesite=lax';
    } catch (e) {}
  }

  var anzahl = w.LC_KORB_ANZAHL;
  if (!kopf.keks && !lesen(KORB) && typeof anzahl === 'number' && anzahl === 0) return;

  /* Code der Liste in discount_codes, sonst null; undefined = Antwort unbrauchbar. */
  function codeImKorb(korb) {
    var liste = korb && korb.discount_codes;
    if (!Array.isArray(liste)) return undefined;
    for (var i = 0; i < liste.length; i++) {
      var roh = liste[i] && liste[i].code;
      var c = typeof roh === 'string' ? roh.trim().toUpperCase() : '';
      if (c && kopf.codes.indexOf(c) !== -1) return c;
    }
    return null;
  }

  /* Nachweislich leer: item_count 0 (oder ohne item_count eine leere items-Liste). */
  function leer(korb) {
    if (typeof korb.item_count === 'number') return korb.item_count === 0;
    return Array.isArray(korb.items) && korb.items.length === 0;
  }

  w.fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
    .then(function (r) { return r && r.ok ? r.json() : null; })
    .then(function (korb) {
      var code = codeImKorb(korb);
      if (code === undefined) return;
      if (code) {
        setzen(KORB, code);
        setzen(WIDERLEGT, null);
        return;
      }
      setzen(KORB, null);
      if (kopf.keks) {
        if (!leer(korb)) setzen(WIDERLEGT, kopf.keks);
        /* Leerer Korb: Cookie bleibt gueltig (Winback-Modus bleibt), ausser es
           ist schon widerlegt und nur der Korb-Merker hatte gezaehlt. */
        else if (String(lesen(WIDERLEGT) || '').trim().toUpperCase() !== kopf.keks) return;
      }
      d.documentElement.classList.remove('lc-winback');
      w.lcWinback = null;
    })
    .catch(function () {});
})();
